/**
 * @file 权限模拟状态
 * @description 顶栏主账号 / 子账号切换；供业务页按角色切换展示。
 *
 * @whenToUse 开发期权限模拟、按角色切换页面形态。
 * @whenNotToUse 真实登录鉴权（用 auth）。
 */

import { create } from 'zustand'

/** 权限模拟角色：主账号 / 子账号 */
export type PermissionSimRole = 'main' | 'sub'

type PermissionSimState = {
  /** 当前模拟角色 */
  role: PermissionSimRole
  /** 切换模拟角色 */
  setRole: (role: PermissionSimRole) => void
}

export const usePermissionSimStore = create<PermissionSimState>((set) => ({
  role: 'main',
  setRole: (role) => set({ role }),
}))
